import { css } from '@emotion/css';

import { colors } from '@editor2/styles/colors';

export const metadataBlock = css`
	border: 1px solid ${colors.border};
	border-radius: 4px;
	margin-bottom: 20px;

	.header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 10px 16px;
		color: #495057;
		border-radius: 4px;
		font-weight: 600;
	}

	.collapseIcon {
		transition-duration: 500ms;
	}

	.collapseIconRotate {
		transform: rotate(-90deg);
		transition-duration: 500ms;
	}

	.collapseIcon,
	.collapseIconRotate {
		:hover {
			cursor: pointer;
		}
	}

	.body {
		padding: 16px;
		color: ${colors.mainText};

		.row {
			margin-bottom: 10px;
		}
	}
`;
